import React from "react";
import {Row} from "antd";
import {Box, CollapseHeaderNumber} from "./styles";
import {
    PercentageOutlined,
    FileSearchOutlined,
    CheckCircleOutlined,
    TeamOutlined
} from "@ant-design/icons";
import {ConditionalTooltip} from "../_defaultComponents/ConditionalTooltip/ConditionalTooltip";
import {useTranslation} from "react-i18next";

const DataBox = ({data, name, onClick = () => {}}) => {
    const {t} = useTranslation(["companyPage", "shiftCompliance"]);
    const plannedCourierColor = "#0958d9";
    const realizedCourierColor = "#08979c";
    const complianceRateColor = "#d46b08";
    const currentlyAvailableCourierCountColor = "#8fbe24";
    const isGeneralStatistic = name === t("generalStatistic", {ns: "shiftCompliance"});

    return (
        <Row justify="space-between" onClick={onClick}>
            <p>{name?.capitalize() || data.name?.capitalize()}</p>
            <Row>
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.scheduledCourier`, {ns: "companyPage"})}
                    child={
                        <Box color={plannedCourierColor}>
                            <FileSearchOutlined
                                style={{fontSize: "18px", color: plannedCourierColor}}
                            />
                            <CollapseHeaderNumber color={plannedCourierColor}>
                                {isGeneralStatistic
                                    ? data?.totalPlannedCourierCount
                                    : data?.plannedCourierCount}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.realizedCourier`, {ns: "companyPage"})}
                    child={
                        <Box color={realizedCourierColor}>
                            <CheckCircleOutlined
                                style={{fontSize: "18px", color: realizedCourierColor}}
                            />
                            <CollapseHeaderNumber color={realizedCourierColor}>
                                {isGeneralStatistic
                                    ? data?.totalRealizedShiftCount
                                    : data?.realizedCourierCount}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.currentlyAvailableCouriers`, {ns: "companyPage"})}
                    child={
                        <Box color={currentlyAvailableCourierCountColor}>
                            <TeamOutlined
                                style={{
                                    fontSize: "18px",
                                    color: currentlyAvailableCourierCountColor
                                }}
                            />
                            <CollapseHeaderNumber color={currentlyAvailableCourierCountColor}>
                                {isGeneralStatistic
                                    ? data?.totalCurrentlyAvailableCourierCount
                                    : data?.currentlyAvailableCourierCount}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
                <ConditionalTooltip
                    condition
                    text={t(`detailButtons.complianceRate`, {ns: "companyPage"})}
                    child={
                        <Box color={complianceRateColor}>
                            <PercentageOutlined
                                style={{fontSize: "18px", color: complianceRateColor}}
                            />
                            <CollapseHeaderNumber color={complianceRateColor}>
                                {data?.complianceRate}
                            </CollapseHeaderNumber>
                        </Box>
                    }
                    placement={"top"}
                />
            </Row>
        </Row>
    );
};

export default DataBox;
